export default __webpack_public_path__ + "static/new-technologies-benefit-9f1f66c426a04a5b76537035db24c1a7.svg";